import { render } from "./sdtm_conversion.vue?vue&type=template&id=fd033834"
import script from "./sdtm_conversion.js?vue&type=script&lang=js"
export * from "./sdtm_conversion.js?vue&type=script&lang=js"

import "./sdtm_conversion.vue?vue&type=style&index=0&id=fd033834&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__